export const defaultLocale = 'tr';
export const supportedLocales = {
    en: 'English',
    tr: 'Turkish',
};
export const documentationLocales = {
    en: 'en-US',
    tr: 'tr-TR',
};
//# sourceMappingURL=supportedLocales.js.map